import { GenericAccordion, FieldRow } from '../SettingsUI';
import type { FieldSetting } from '../../types';

const FIELDS = [
  { label: 'First Name', key: 'firstName' },
  { label: 'Last Name', key: 'lastName' },
  { label: 'Email', key: 'email' },
  { label: 'User Role', key: 'category' },
  { label: 'Time Zone', key: 'timezone' }
];

const FORCED_CHECKED: FieldSetting = {
  mentee: true,
  mentor: true,
  admin: true,
  mandatory: true
};

interface BasicPanelProps {
  fieldSettings: Record<string, FieldSetting>;
  updateField: (
    key: string,
    role: 'mentee' | 'mentor' | 'admin' | 'mandatory',
    value: boolean
  ) => void;
  disabled?: boolean;
}

export function BasicPanel({ updateField, disabled }: BasicPanelProps) {
  return (
    <GenericAccordion title="Basic">
      {FIELDS.map(({ label, key }) => (
        <FieldRow
          key={key}
          label={label}
          fieldKey={key}
          data={FORCED_CHECKED}
          onChange={(role, val) => updateField(key, role, val)}
          onMandatoryChange={(val) => updateField(key, 'mandatory', val)}
          disabled
        />
      ))}
    </GenericAccordion>
  );
}
